import {useEffect, useRef} from 'react';
import {accessTokenKey} from '@core/Constants/app-storage-keys';
import {setValueToLocalStorage} from '@core/Hooks/use-local-storage';
import {LoadingIcon} from '@core/VisualComponents/Icons/LoadingIcon';

export function ExtensionSessionPage() {
    const hasStarted = useRef(false);

    useEffect(() => {
        if (hasStarted.current) {
            return;
        }
        hasStarted.current = true;

        const exchange = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            const returnPath = params.get('returnPath');
            if (!code) {
                window.location.replace('/signin');
                return;
            }

            const response = await fetch('/api/extension/auth/session/exchange', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({code})
            });
            if (!response.ok) {
                window.location.replace('/signin');
                return;
            }

            const result = await response.json();
            setValueToLocalStorage(accessTokenKey, result.accessToken);
            const target = returnPath?.startsWith('/') && !returnPath.startsWith('//') && !returnPath.includes('\\')
                ? returnPath
                : '/';
            window.location.replace(target);
        };

        exchange().catch(() => {
            window.location.replace('/signin');
        });
    }, []);

    return <div style={{height: '100%', display: 'grid', placeItems: 'center'}}>
        <LoadingIcon/>
    </div>;
}
